<div class="actionMenu">
  <mat-form-field appearance="standard">
    <mat-label>Папки</mat-label>
    <input [formControl]="searchControl" matInput type="text" placeholder="Поиск" />
    <button mat-icon-button matSuffix (click)="clear()">
      <mat-icon>clear</mat-icon>
    </button>
    <button mat-icon-button matSuffix (click)="collapse()">
      <mat-icon>close_fullscreen</mat-icon>
    </button>
  </mat-form-field>
</div>
<mat-tree #treeSelector [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodePadding
    (click)="toggle(node)"
    (contextmenu)="onRightClick($event, node)"
  >
    <a [ngClass]="{ active: selectedFolder && selectedFolder.id === node.id }" class="link">
      <div class="img_holder">
        <div class="no-image" *ngIf="!node.image">
          <mat-icon>
            <mat-icon>photo_camera</mat-icon>
          </mat-icon>
        </div>
        <img
          class="folderThumb"
          *ngIf="node.image"
          [src]="getImgSrc(node.image)"
          [alt]="node.description"
        />
      </div>
      <p class="folderDescription">{{ node.name }}</p>
    </a>
  </mat-tree-node>
  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    (contextmenu)="onRightClick($event, node)"
    matTreeNodePadding
  >
    <a
      [ngClass]="{ active: selectedFolder && selectedFolder.id === node.id }"
      matTreeNodeToggle
      class="link"
    >
      <div class="img_holder">
        <div class="no-image" *ngIf="!node.image">
          <mat-icon>
            <mat-icon>photo_camera</mat-icon>
          </mat-icon>
        </div>

        <img
          class="folderThumb"
          *ngIf="node.image"
          [src]="getImgSrc(node.image)"
          [alt]="node.description"
        />
      </div>

      <p class="folderDescription">{{ node.name }}</p>
      <mat-icon class="mat-icon-rtl-mirror">
        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
      </mat-icon>
    </a>
  </mat-tree-node>
</mat-tree>

<!-- an hidden div is created to set the position of appearance of the menu-->
<div
  style="visibility: hidden; position: fixed"
  [style.left]="menuTopLeftPosition.x"
  [style.top]="menuTopLeftPosition.y"
  [matMenuTriggerFor]="rightMenu"
></div>

<!-- standard material menu -->
<mat-menu #rightMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="createFolder()">
      <mat-icon>add</mat-icon> Создать папку в корне
    </button>
    <button mat-menu-item (click)="createFolder(item)">
      <mat-icon>add</mat-icon> Создать папку в {{ item.name }}
    </button>
    <button mat-menu-item (click)="editFolder(item)">
      <mat-icon>edit</mat-icon> Переименовать
    </button>
    <button mat-menu-item (click)="updateImage(item)">
      <mat-icon>photo_camera</mat-icon> Изменить картинку группы
    </button>
    <button mat-menu-item (click)="delete(item)"><mat-icon>delete</mat-icon> Удалить</button>
  </ng-template>
</mat-menu>

<input #fileInput (change)="handleFileSelect($event)" type="file" class="fileInput" />
